import { Batch } from '../_models/batch';
import { Observable } from 'rxjs';
import {DbService,BATCH_STORE_NAME } from './DbService';

class BatchService {

  dbservice:DbService;


  constructor(){
    console.log("in constructor")
    this.dbservice = new DbService();
    this.dbservice.connect();
    console.log(this.dbservice.iteachDB);
  }

  addBatches(batches: Batch[]): any {
    return this.dbservice.saveAll(BATCH_STORE_NAME, batches);
  }

  getBatches(): Promise<Batch[]> {
    console.log("in get batches");
    console.log(this.dbservice.iteachDB);
    return this.dbservice.getAll(BATCH_STORE_NAME);
    // this.dbservice.getAll(BATCH_STORE_NAME).then((data)=>console.log(data, 'here'));
  }
  

  /*getBatchesForInstructor(instructorId: number): Promise<Batch[]> {
    return this.dbService.getByIndex(BATCH_STORE_NAME, BATCH_STORE_INDEX_INSTRUCTOR, instructorId);
  }*/
}

export default BatchService
